// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class ClusterFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const region = this.view.getStateRegion();
      const office = this.view.getStateOffice();
      const division = this.view.getStateDivision();
      const section = this.view.getStateSection();
      const unit = this.view.getStateUnit();
      if (region === undefined) {
        throw new Error("Select OCOM");
      } else if (office === "") {
        throw new Error("Select Location");
      } else if (division === "") {
        throw new Error("Select Region");
      } else if (section === "") {
        throw new Error("Select Subport/ IPEE/ Main RIOU");
      } else if (unit === "") {
        throw new Error("Select Division");
      }
      this.change.region = region;
      this.change.office = office;
      this.change.division = division;
      this.change.section = section;
      this.change.unit = unit;
      this.change.name = this.view.state.name;
      this.change.description = this.view.state.description;
      this.change.status = "active";
      // console.warn("DD: ", this.change);
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change.status = "active";
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default ClusterFormPresenter;
